module.exports = __webpack_public_path__ + "static/media/birthday-cake-cake-svgrepo-com.15b926a7.svg";